export default "__VITE_ASSET__8475a9ae__"